import { WPCategory } from 'types/categories';
import { useApiRequest } from './useApiRequest';

type UseCategories = {
  readonly skip?: boolean;
  readonly per_page?: number;
};

const endpoint = 'categories';

export const useCategories = <T extends WPCategory>(options?: UseCategories) => {
  const { skip, ...restOptions } = options || {};
  return useApiRequest<T[]>({
    endpoint,
    cacheKey: `categories`,
    options: restOptions,
    embed: false,
  });
};
